<template>
    <section class=" font-montserrat">
        <header class=" flex justify-around pt-6 pb-6 fixed w-full z-10 bg-white lg:justify-between">
            <div>
                <router-link to="/"><img class="lg:pl-10 md:w-40 md:pt-3 w-40"
                        src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg"
                        alt="logo"></router-link>

            </div>
            <nav class=" lg:hidden">
                <ul>
                    <li class=" inline-block mr-6 font-semibold"><router-link :class="{ active: $route.name === 'home' }"
                            to="/">Home</router-link></li>
                    <li class="inline-block mr-6 font-semibold"><router-link :class="{ active: $route.name === 'about' }"
                            to="/about"> About Us</router-link></li>
                    <li class="inline-block mr-6 font-semibold"><router-link
                            :class="{ active: $route.name === 'dso-affiliate' }" to="/dso-affiliate">DSP
                            Affiliates</router-link></li>
                    <li class="inline-block mr-6 font-semibold"><router-link
                            :class="{ active: $route.name === 'hp-scheme' }" to="/hp-scheme">CG Hire
                            Purchase</router-link></li>
                    <li class="inline-block mr-6 font-semibold"><router-link :class="{ active: $route.name === 'faqs' }"
                            to="/faqs">FAQs</router-link></li>
                    <li class="inline-block mr-6 font-semibold"><router-link
                            :class="{ active: $route.name === 'register' }" to="/register">Register</router-link></li>
                    <li class="inline-block mr-6 font-semibold"><router-link
                            :class="{ active: $route.name === 'contact' }" to="/contact">Contact Us</router-link></li>
                </ul>
            </nav>

            <div class=" bg-blue-800 text-white p-2 rounded-xl font-semibold lg:hidden  ">
                <p><router-link to="/trackingnumber">Track Order</router-link></p>
            </div>

            <div>
                <i class=" fa fa-bars fa-2x text-blue-600 hidden lg:block mt-4 text-2xl pr-10" @click="toggleMobileNav"
                    :class="{ 'icon-active': mobileNav }"></i>
            </div>

            <transition name="mobile-nav" class="  w-full">

                <nav v-show="mobileNav" class="dropDDownNav flex ">
                    <div class="w-1/2 absolute top-0 left-0  rounded-r-2xl h-screen p-2"
                        style="background-color:#0048AE">
                        <ul>
                            <li class="  p-2 font-semibold text-white"><router-link to="/">Home</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-white"><router-link to="/about"> About
                                    Us</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-white"><router-link to="/faqs">FAQs</router-link>
                            </li>
                            <li class=" p-2 font-semibold mt-2 text-white"><router-link
                                    to="/contact">Contact</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-white"><router-link to="/dso-affiliate">DSP
                                    Affiliates</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-white"><router-link to="/hp-scheme">CG Hire
                                    Purchase</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-white"><router-link
                                    to="/register">Register</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-white"><router-link to="/trackingnumber">Track
                                    Order</router-link></li>
                        </ul>

                        <div class=" flex mt-8">
                            <a href="https://twitter.com/_CarryGoNg?t=hr9WEcQiMa56dd8G6ilY-g&s=09"><i
                                    class="fa fa-twitter text-white fa-2x"></i></a>
                            <a href="https://www.facebook.com/CarryGo-Logistech-100760155865136/"><i
                                    class="fa fa-facebook fa-2x text-white ml-2"></i></a>
                            <a href="https://instagram.com/carrygo_ng?utm_medium=copy_link"><i
                                    class="fa fa-instagram fa-2x text-white ml-3"></i></a>
                        </div>
                    </div>
                    <div @click="toggleMobileNav" class="modal-backdrop w-1/2">

                    </div>

                </nav>

            </transition>
        </header>
    </section>
</template>

<script>
export default {
    data() {
        return {
            mobile: true,
            mobileNav: null,
        }
    },

    methods: {
        toggleMobileNav() {
            this.mobileNav = !this.mobileNav
        },
    }
}
</script>

<style scoped>
.modal-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.2);
}
</style>